import React, { FC } from 'react';
import ApexCharts from 'react-apexcharts';

const CompensationInfoChart: FC<{ pieChartData: string }> = ({ pieChartData }) => {
  const { series, labels, title } = JSON.parse(pieChartData);

  return (
    <ApexCharts
      type="pie"
      series={series.map((s: string) => parseFloat(s))}
      options={{
        chart: {
          fontFamily: 'Lato'
        },
        colors: ['#326299', '#4A90E2', '#7DB9FF', '#AEC7E3'],
        dataLabels: {
          formatter: value => `${value}%`
        },
        title: {
          text: title
        },
        tooltip: {
          y: {
            formatter: (value: number) => `${value}%`
          }
        },
        labels,
        legend: {
          position: 'bottom'
        }
      }}
    />
  );
};

export default CompensationInfoChart;
